// extracted by mini-css-extract-plugin
export default {"futureActivityOnly":"activity_futureActivityOnly__SnQbE","SwitchText":"activity_SwitchText__8SMgW","icon":"activity_icon__pK3hU","iconDanger":"activity_iconDanger__oy-U9"};